// extracted by mini-css-extract-plugin
export default {"root":"_2FLF1","icon":"_2u5nE","title":"_8hxAU","subtitle":"_3dS9i","button":"_1k1Uk"};